module.exports = __webpack_public_path__ + "static/pay_result_succ.e80e1f2b.png";